import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Search from '@mui/icons-material/Search';
import type { ButtonProps } from '@mui/material/Button';

interface SearchButtonProps extends Omit<ButtonProps, 'children'> {
  label?: string;
  tooltipLabel?: string;
}

export default function SearchButton({
  label = 'Search',
  tooltipLabel,
  ...rest
}: SearchButtonProps) {
  return (
    <Tooltip arrow title={tooltipLabel ? tooltipLabel : ''}>
      <span>
        <Button
          {...rest}
          variant="contained"
          startIcon={<Search />}
          sx={{
            width: '116.75px',
            textTransform: 'none',
            ml: '8px',
            height: 40,
            ...rest.sx,
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
